import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useServiceType, ServiceType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<ServiceType>
      useData={useServiceType}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
